import React, { ImgHTMLAttributes } from 'react'
import { transformLocalAssetUrl } from 'utils'

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  src: string
}

const LocalImage = ({ src, alt, ...props }: Props) => {
  return <img src={transformLocalAssetUrl(src)} alt={alt} {...props} />
}

export default LocalImage
